<template>
    <div class="content mt20">
       <div class="account-content bgfff">
         <div class="one-bd clearfix">
            <a href="javascript:void(0);" :class="(typeId != 2&&typeId !=3)?'active':''" @click="listTab(1)">微信榜单</a>
            <a href="javascript:void(0);" :class="typeId==2?'active':''"  @click="listTab(2)">微博榜单</a>
            <a href="javascript:void(0);" :class="typeId==3?'active':''" @click="listTab(3)">头条榜单</a>
         </div>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix" v-if="typeId != 2&&typeId !=3">
                <div class="btns-group time-tab fl">
                    <a class="active" href="/mediaList">公众号</a>
                    <router-link :to="{path:'/mediaList/mediaListArticle',query:{id:1}}" href="#/mediaList/mediaListArticle">文章</router-link>
                </div>
                <div class="btns-group time-tab ml20 fl">
                    <a  @click="dateListClick(1,1)" :class="typeCurrent!=2&&typeCurrent!=3?'active':''" href="javascript:void(0);">日榜</a>
                    <a class="" @click="dateListClick(1,2)" :class="typeCurrent==2?'active':''" href="javascript:void(0);">周榜</a>
                    <a class="" @click="dateListClick(1,3)" :class="typeCurrent==3?'active':''" href="javascript:void(0);">月榜</a>
                </div>
                <div class="w194 ml25 form-time fl" v-if="typeCurrent==1">
                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate" showButtons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                </div>
                <div class="dropdown-toggle w194 ml20 fl" v-if="typeCurrent!=1">
                    <div class="dropdown">
                        <span>{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateList" :key="index" @click="dateClick(item)">
                               <a href="javaScript:void(0)" :class="(dateOne==item?'active':'')">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown-toggle w194 ml20 fl">
                    <div class="dropdown">
                        <span>{{tagFont}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w447">
                        <div class="search-warp w210">
                            <input type="text" name="search" placeholder="请输入标签名" class="input-text" v-model="searchSel" @keyup="tagSearch"> 
                            <span class="search-btn" href="javascript:void(0);" @click="tagSearch">
                                <i class="icons search-icon1"></i>
                            </span>
                        </div>
                        <ul class="dropdown-menu" role="menu">
                            <li v-for="(item,index) in tagList" :key="index">
                               <a href="javaScript:void(0);" @click="tagClick(item.id,item.name)">{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <a :href="Url" download="w3logo" v-if="totalCount<=200" class="btn btn-blue fr"><i class="icons icon-export"></i>导出</a>
                <button class="btn btn-blue fr" @click="exportBtn" v-if="totalCount>200"><i class="icons icon-export"></i>导出</button>
            
            </div>
            <div class="bd clearfix" v-if="typeId == 2">
                <div class="btns-group time-tab fl">
                    <a class="active">微博号</a>
                </div>
                <div class="btns-group time-tab ml20 fl">
                    <a href="javascript:void(0);" :class="typeCurrent!=2&&typeCurrent!=3?'active':''" @click="dateListClick(2,1)">日榜</a>
                    <a href="javascript:void(0);" :class="typeCurrent==2?'active':''" @click="dateListClick(2,2)">周榜</a>
                    <a href="javascript:void(0);" :class="typeCurrent==3?'active':''" @click="dateListClick(2,3)">月榜</a>
                </div>
                <div class="w194 ml25 form-time fl" v-if="typeCurrent==1">
                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate" showButtons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                </div>
                <div class="dropdown-toggle w194 ml20 fl" v-if="typeCurrent!=1">
                    <div class="dropdown">
                        <span>{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateList" :key="index" @click="dateClick(item)">
                               <a href="javaScript:void(0)" :class="(dateOne==item?'active':'')">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown-toggle w194 ml20 fl">
                    <div class="dropdown">
                        <span>{{tagFont}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w447">
                        <div class="search-warp w210">
                            <input type="text" name="search" placeholder="请输入标签名" class="input-text" v-model="searchSel" @keyup="tagSearch"> 
                            <span class="search-btn" href="javascript:void(0);" @click="tagSearch">
                                <i class="icons search-icon1"></i>
                            </span>
                        </div>
                        <ul class="dropdown-menu" role="menu">
                            <li v-for="(item,index) in tagList" :key="index">
                               <a href="javaScript:void(0);" @click="tagClick(item.id,item.name)">{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <a :href="Url" download="w3logo" v-if="totalCount<=200" class="btn btn-blue fr"><i class="icons icon-export"></i>导出</a>
                <button class="btn btn-blue fr" @click="exportBtn" v-if="totalCount>200"><i class="icons icon-export"></i>导出</button>
            </div>
            <div class="bd clearfix" v-if="typeId == 3">
                <div class="btns-group time-tab fl">
                    <a class="active">头条号</a>
                    <router-link :to="{path:'/mediaList/hotText',query:{id:3}}">热文</router-link>
                </div>
                <div class="btns-group time-tab ml20 fl">
                    <a  @click="dateListClick(3,1)" :class="typeCurrent!=2&&typeCurrent!=3?'active':''" href="javascript:void(0);">日榜</a>
                    <a class="" @click="dateListClick(3,2)" :class="typeCurrent==2?'active':''" href="javascript:void(0);">周榜</a>
                    <a class="" @click="dateListClick(3,3)" :class="typeCurrent==3?'active':''" href="javascript:void(0);">月榜</a>
                </div>
                <div class="w194 ml25 form-time fl" v-if="typeCurrent==1">
                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate" showButtons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                </div>
                <div class="dropdown-toggle w194 ml20 fl" v-if="typeCurrent!=1">
                    <div class="dropdown">
                        <span>{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateList" :key="index" @click="dateClick(item)">
                               <a href="javaScript:void(0)" :class="(dateOne==item?'active':'')">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown-toggle w194 ml20 fl">
                    <div class="dropdown">
                        <span>{{tagFont}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w447">
                        <div class="search-warp w210">
                            <input type="text" name="search" placeholder="请输入标签名" class="input-text" v-model="searchSel" @keyup="tagSearch"> 
                            <span class="search-btn" href="javascript:void(0);" @click="tagSearch">
                                <i class="icons search-icon1"></i>
                            </span>
                        </div>
                        <ul class="dropdown-menu" role="menu">
                            <li v-for="(item,index) in tagList" :key="index">
                               <a href="javaScript:void(0);" @click="tagClick(item.id,item.name)">{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <a :href="Url" download="w3logo" v-if="totalCount<=200" class="btn btn-blue fr"><i class="icons icon-export"></i>导出</a>
                <button class="btn btn-blue fr" @click="exportBtn" v-if="totalCount>200"><i class="icons icon-export"></i>导出</button>
            </div>
            <div class="table-warp mt20">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="">
                    </colgroup>
                    <thead>
                        <tr v-if="typeId == 1">
                            <th>排名</th>
                            <th>公众号</th>
                            <th>发布次数 / 篇数</th>
                            <th>总阅读数</th>
                            <th>最高阅读数</th>
                            <th>平均阅读数</th>
                            <!-- <th>总在看数</th> -->
                            <th>S-WCI</th>
                        </tr>
                        <tr v-if="typeId == 2">
                            <th>排名</th>
                            <th>微博号</th>
                            <th>发博/原创</th>
                            <th>转发数</th>
                            <th>评论数</th>
                            <th>原创转发</th>
                            <th>原创评论</th>
                            <th>总点赞数</th>
                            <th>BCI<a class="edit color-blue" @click="toUsage('http://www.gsdata.cn/site/usage-2')"><i class="icons icon-wci"></i></a></th>
                        </tr>
                        <tr v-if="typeId == 3">
                            <th>排名</th>
                            <th>头条号</th>
                            <th>发文量</th>
                            <th>总阅读数</th>
                            <th>平均阅读数</th>
                            <th>总评论量</th>
                            <th>平均评论量</th>
                            <th>TGI<a class="edit color-blue" @click="toUsage('http://www.gsdata.cn/site/usage-3')"><i class="icons icon-wci"></i></a></th>
                        </tr>
                    </thead>
                    <tbody v-if="typeId == 1">
                        <tr class="" v-if="nodata">
                            <td colspan="8"><div class="no-data" ><span class="text">没有数据哦...</span></div></td>
                        </tr>
                        <tr v-for="(item,index) in mediaList" :key="index">
                            <td><span :class="'num-span no'+item.id">{{index+1}}</span></td>
                            <td>
                                <div class="img-word">
                                    <div class="img"><img :src="item.wxPic"></div>
                                    <div class="word pl5">
                                        <span class="name db">{{item.wxName}}</span>
                                        <span class="en-name db">{{item.nickName}}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="n1">{{item.nums}}</td>
                            <td class="n2">{{item.readCount}}</td>
                            <td class="n3">{{item.maxNum}}</td>
                            <td>{{item.avgNum}}</td>
                            <!-- <td>{{item.likenumAll}}</td> -->
                            <td>{{item.wci}}</td>
                        </tr>
                    </tbody>
                    <tbody v-if="typeId == 2">
                        <tr class="" v-if="nodata">
                            <td colspan="9"><div class="no-data" ><span class="text">没有数据哦...</span></div></td>
                        </tr>
                        <tr v-for="(item,index) in mediaList" :key="index">
                            <td><span :class="'num-span no'+item.id">{{index+1}}</span></td>
                            <td>
                                <div class="img-word">
                                    <div class="img"><img :src="item.weiboPic"></div>
                                    <div class="word pl5">
                                        <span class="name db">{{item.weiboNickname}}</span>
                                        <span class="en-name db">{{item.weiboNo}}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="n1">{{item.nums}}</td>
                            <td class="n2">{{item.repostCount}}</td>
                            <td class="n3">{{item.commentCount}}</td>
                            <td>{{item.originRepostCount}}</td>
                            <td>{{item.originCommentCount}}</td>
                            <td>{{item.likeCount}}</td>
                            <td>{{item.bic}}</td>
                        </tr>
                    </tbody>
                    <tbody v-if="typeId == 3">
                        <tr class="" v-if="nodata">
                            <td colspan="8"><div class="no-data" ><span class="text">没有数据哦...</span></div></td>
                        </tr>
                        <tr v-for="(item,index) in mediaList" :key="index">
                            <td><span :class="'num-span no'+item.id">{{index+1}}</span></td>
                            <td>
                                <div class="img-word">
                                    <div class="img"><img :src="item.wxPic"></div>
                                    <div class="word pl5">
                                        <span class="name db">{{item.toutiaoNickname}}</span>
                                        <span class="en-name db">{{item.toutiaoUid}}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="n1">{{item.publishNewsNum}}</td>
                            <td class="n2">{{item.readCount}}</td>
                            <td class="n3">{{item.readAvg}}</td>
                            <td>{{item.commentCount}}</td>
                            <td>{{item.commentAvg}}</td>
                            <td>{{item.tgi}}</td>
                        </tr>
                    </tbody>
                </table>
                 <!-- 分页 -->
                 <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
            <!-- 提示弹框 -->
            <!-- <Dialog ref="exportDialog" type="normal" title="导出" width="540" :callback="exportBtn">
                <div slot="mdBox">
                    <div class="adduser">
                        <div class="form-group clearfix">
                            <label class="control-label w">导出数据： </label>
                            <div class="fl">榜单</div>
                        </div>
                        <div class="form-group mt20 clearfix">
                            <label class="control-label w">TOP设置：</label>
                            <div class="w400 fl">
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="5" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>5</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="10" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>10</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="25" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>25</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="50" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>50</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="100" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>100</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="200" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>200</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="300" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>300</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="500" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>500</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="1000" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <span>1000</span>
                                </div>
                                <div class="checkbox-warp mr20 fl clearfix">
                                    <div class="radio radio1 fl">
                                        <input type="radio" v-model="sel" value="1" class="radio-i">
                                        <span class="radio-ico"></span>
                                    </div>
                                    <input class="input-text w110" v-model="customSel" value="" placeholder="自定义选择" />
                                </div>
                            </div>
                        </div>
                        <div class="form-group clearfix">
                            <label class="control-label w">文件类型：</label>
                            <div class="checkbox-warp mr20 fl clearfix">
                                <div class="radio radio1 fl">
                                    <input type="radio" v-model="sel1" value="1" class="radio-i">
                                    <span class="radio-ico"></span>
                                </div>
                                <span>Excel</span>
                            </div>
                            <div class="checkbox-warp mr20 fl clearfix">
                                <div class="radio radio1 fl">
                                    <input type="radio" v-model="sel1" value="2" class="radio-i">
                                    <span class="radio-ico"></span>
                                </div>
                                <span>图片</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog> -->
       </div>
  	</div>
</template>
<script>
import Page from '@/components/page'
import Dialog from '@/components/dialog'
import VueDatepickerLocal from 'vue-datepicker-local'
export default {
    components: {Page,Dialog,VueDatepickerLocal},
    data() {
        return {
           mediaList:[],//微信列表
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           currentTab:1,//当前active
           currentTab1:1,//当前日榜active
           sel:5,//Top 设置
           sel1:1,//文件类型
           customSel:'',//自定义选择
           typeId:1,//id
           typeCurrent:1,//周日榜
           tagList:[],//标签
           tagFont:'全部',//标签默认
           searchSel:'',//标签搜索
           dateOne:'',//选中时间
           timeRange:'',//默认日
           dateList:[],//时间列表
           tagId:'',//标签id
           Url:'',//url
           totalNum:200,
           searchData:'',
           labelList:'',
           nodata:false,

        }
    },
    mounted() {
        let that = this;
        
        var myDate = new Date();
        myDate.setDate(myDate.getDate() - 1);
        that.timeRange = myDate.toLocaleDateString();
        if(that.$route.query.id==undefined){
            that.typeId= that.typeId;
        }else{
            that.typeId= that.$route.query.id;
        }
        
        if(that.$route.query.type1==undefined){
            that.dateOne = that.timeRange;
        }else{
            that.dateOne = that.$route.query.type1;
        }
        
        if(that.$route.query.type==undefined){
            that.typeCurrent= that.typeCurrent;
        }else{
            that.typeCurrent= that.$route.query.type;
        }
        that.dataAjax(that.typeId,1);
        that.dataAjax1();
        
        
    },
    created() {
		
    },
    methods: {
        toUsage(e){
            window.open(e,'_blank');
        },
        tagSearch () {//标签搜索
            let that = this;
            let list = [];
            let lableList = that.labelList;
            let keyWord = that.searchSel;
            for(let i of lableList){
                if(i.name.indexOf(keyWord) != -1){
                    list.push(i);
                }
            }
            that.tagList = list;
        },
        tagClick(id,name){//标签选择
            let that =this;
            that.tagFont = name;
            that.tagId = id;
            let type = that.currentTab;
            that.dataAjax(type,1);
        },
        exportBtn(type,cPage){//导出确定
            let that = this;
             type = that.currentTab;
             cPage = 1;
            let url = '';
            if(cPage===0){
               that.currentPage = 1;
            }
           if(type == 1){
               url = '/rank/wximport';
           }else if(type==2){
               url = '/rank/wbimport'
           }else if(type==3){
               url = '/rank/ttimport'
           }
            that.$api.post(url,{type:that.typeCurrent,time:that.dateOne,flid:that.tagId},r=>{
                  that.$parent.returnCode(r,function(){

              })
            });
        },
        dateClick(type1){//点击时间下拉
            let that = this;
            that.$router.push({
                path: '/mediaList?type='+that.currentTab,
                query: {
                    id:that.typeId,
                    type:that.typeCurrent,
                    type1: type1,                    
                }
            });
            that.dateOne = that.$route.query.type1;
            that.dataAjax(that.currentTab,0);            

        },
        dateListClick(type,type1){//点击切换 日周月榜
            let that = this;
            that.typeCurrent = type1;
            that.currentTab = type;
            if(type1==1){
                that.dateOne = that.timeRange;
                that.dataAjax(type,0);
                that.$router.push({
                    path: '/mediaList',
                    query: {
                        id:that.currentTab,
                        type: that.typeCurrent,
                        type1:that.dateOne,
                    }
                });
                that.typeCurrent= that.$route.query.type;
            }else{
                that.$api.post('/rank/weekmonth',{type:that.typeCurrent,source:that.currentTab},r=>{
                    that.$parent.returnCode(r,function(){
                        that.dateList = r.data;
                        that.dateOne = that.dateList[0];
                        that.dataAjax(type,0);
                        that.$router.push({
                            path: '/mediaList',
                            query: {
                                id:that.currentTab,
                                type: that.typeCurrent,
                                type1:that.dateOne,
                            }
                        });
                        that.typeCurrent= that.$route.query.type;
                    //console.log(that.dateOne);
                    })
                })
            }
            
        },
        listTab(type){//点击切换 微信 微博 头条
            let that = this;
            that.currentTab = type;
            that.typeCurrent = 1;
            that.dateOne = '';
            that.dataAjax(type,0);
            that.$router.push({
                path: '/mediaList',
                query: {
                    id: that.currentTab
                }
            });
            that.typeId= that.$route.query.id;    
        },
        getTableData(type){//分页
            let that = this;
            type = that.currentPage;
            that.dataAjax(that.typeId,0);
        },
        disabledDate(time,format){
            let that = this;
            if(time.getTime() > new Date().getTime()) return true;
        },
        selectedDate(date) {//点击日榜时间确定
            let that = this;
            that.dateOne = that.timeRange = that.$utils.dateConversion(that.timeRange,0);
            that.dataAjax(that.typeId,0);
        },
        dataAjax(type,cPage){//微信列表
            let that = this;
            let url = '';
            cPage = 1;
            if(cPage===0){
               that.currentPage = 1;
            }
            if(type == 1){
               url = 'rank/wxrank';
            }else if(type==2){
               url = 'rank/weiborank'
            }else if(type==3){
               url = 'rank/ttrank'
            }
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post(url,{page:that.currentPage,pagesize:that.limit,type:that.typeCurrent,time:that.dateOne,flid:that.tagId},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.mediaList=r.data.list;
                    that.totalCount = Number(r.data.total);
                    that.Url = r.data.url;
                    if(that.mediaList.length<=0){
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
              })
            })
       },
       dataAjax1(type,cPage){//标签列表
            let that = this;
            let url = '/label/taglist';
            if(cPage===0){
               that.currentPage = 1;
            }
            that.$api.post(url,{type:that.currentTab},r=>{
                  that.$parent.returnCode(r,function(){
                   that.tagList=r.data;   
                   that.labelList = r.data;
              })
            })
       },
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/mediaList/mediaList.vue